import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as GmouActions from './gmou.actions';
import { GmouService } from '../../services/gmou.service';
import { Router } from '@angular/router';

@Injectable()
export class GmouEffects {
  loadGmou$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GmouActions.loadGmou),
      exhaustMap((_) =>
        this.gmouService.getGmou().pipe(
          map((data) =>
            GmouActions.loadGmouSuccess({
              gmou: data,
            })
          ),
          catchError((error) => {
            if (error.statusText === 'Unknown Error') {
              this.notification.error(
                'Unable to get response from server, please try again'
              );
            }

            return of(
              GmouActions.loadGmouFailure({
                error,
              })
            );
          })
        )
      )
    )
  );

  addGmou$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GmouActions.addGmou),
      concatMap(({ newGmou }) =>
        this.gmouService.createGmou(newGmou).pipe(
          map((data) => {
            this.notification.success('Saved Successfully');
            return GmouActions.addGmouSuccess({
              newGmou: data,
            });
          }),
          catchError((error) => {
            console.log('error ', error);

            return of(
              GmouActions.addGmouFailure({
                error: error.error.message,
              })
            );
          })
        )
      )
    )
  );

  addSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(GmouActions.addGmouSuccess),
        tap(() => {
          return this.router.navigate(['/project']);
        })
      ),
    { dispatch: false }
  );

  updateGmou$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GmouActions.updateGmou),
      concatMap(({ updateGmou }) =>
        this.gmouService.updateGmou(updateGmou).pipe(
          map((data) => {
            // console.log('update effect data ', data);
            this.notification.success('Updated Successfully');
            return GmouActions.updateGmouSuccess({
              updateGmou: data,
            });
          }),
          catchError((error) => {
            return of(GmouActions.updateGmouFailure({ error: error.message }));
          })
        )
      )
    )
  );

  updateSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(GmouActions.updateGmouSuccess),
        tap(() => {
          console.log('navigate');
          return this.router.navigate(['/project']);
        })
      ),
    { dispatch: false }
  );

  removeGmou$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GmouActions.removeGmou),
      map((action) => action.ids),
      concatMap((ids) =>
        this.gmouService.deleteGmou(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return GmouActions.removeGmouSuccess({ ids });
          }),
          catchError((error) =>
            of(
              GmouActions.updateGmouFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private gmouService: GmouService,
    private notification: NotificationService,
    private router: Router
  ) {}
}
